import { ReactNode } from "react";
import { FCAdditionalProps, FCX, ID, iOption } from '@models';
import Button from '@components/Button';
import { ButtonModifiers, iProps as iButtonProps } from '@components/Button/Button';
import cn from 'classnames';

export type ButtonTabsModifiers = "outlined"

export interface iButtonTabsItem extends Omit<iOption, 'title'> {
	title: string | ReactNode,
    buttonProps: FCAdditionalProps & iButtonProps
}

const ButtonTabs: FCX<{
    data: iButtonTabsItem[];
    activeItemId: ID;
	modifiers?: ButtonTabsModifiers[]
    defaultButtonModifiers?: ButtonModifiers[];
	activeButtonModifiers?: ButtonModifiers[];
}> = ({
    data,
    activeItemId,
	modifiers = [],
	defaultButtonModifiers,
	activeButtonModifiers,
    style,
	className,
}) => {
    return (
        <div
            className={
				cn("ButtonTabs", className, ...modifiers)
            }
            style={style}
        >
            {data.map((button) => (
                <Button
                    key={button.id}
                    {...button.buttonProps}
                    className={cn(
                        button.buttonProps.className,
                        'ButtonTabs__item',
	                    {
							'is-active': activeItemId === button.id
	                    }
                    )}
                    modifiers={[
                        ...button.buttonProps.modifiers || [],
	                    ...(activeItemId === button.id ? (activeButtonModifiers ?? ["blue"]) : (defaultButtonModifiers ?? ["white"])),
                    ]}
                >
                    {button.title}
                </Button>
            ))}
        </div>
    );
};

export default ButtonTabs;